export enum PublicEvent {
  ADD_TO_CART = 'add_to_cart',
}
